export const cashMovementDirectionValues = ['in', 'out'] as const;
export type CashMovementDirection = (typeof cashMovementDirectionValues)[number];

export const cashMovementKindValues = [
  'expense',
  'transfer',
  'purchasePayout',
  'adjustment',
  'funding',
  'varianceRecognition',
  'varianceRecovery',
  'overageRemoval',
] as const;
export type CashMovementKind = (typeof cashMovementKindValues)[number];

export const cashMovementSourceTypeValues = [
  'expense',
  'transfer',
  'purchase',
  'adjustment',
  'funding',
  'varianceCase',
] as const;
export type CashMovementSourceType = (typeof cashMovementSourceTypeValues)[number];

export const cashFundingSourceTypeValues = [
  'opening_balance',
  'bank_withdrawal',
  'owner_cash',
  'correction',
  'other',
] as const;
export type CashFundingSourceType = (typeof cashFundingSourceTypeValues)[number];

// Monetary amounts are in minor units (e.g., cents).
export interface CashMovementDto {
  id: string;
  companyId: string;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  cashLocationId: string;
  cashSessionId: string | null;
  transferId: string | null;
  expenseId: string | null;
  movementKind: CashMovementKind;
  direction: CashMovementDirection;
  amount: number;
  description: string | null;
  isReversal: boolean;
  reversalOfMovementId: string | null;
  sourceType: CashMovementSourceType | null;
  sourceId: string | null;
  fundingSourceCategoryId?: string | null;
  fundingSourceCategoryCodeSnapshot?: string | null;
  fundingSourceCategoryDisplayNameSnapshot?: string | null;
  fundingSourceType?: CashFundingSourceType | null;
  fundingReference?: string | null;
  reasonCode?: string | null;
  varianceCaseId?: string | null;
  varianceActionId?: string | null;
  occurredAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListCashMovementsRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  cashSessionId?: string;
  transferId?: string;
  expenseId?: string;
  movementKind?: CashMovementKind;
  direction?: CashMovementDirection;
  sourceType?: CashMovementSourceType;
  sourceId?: string;
  from?: string;
  to?: string;
}

export interface ListCashMovementsResponse {
  items: CashMovementDto[];
}
